import nodeClient from "./node-client";

export const getMedicineDetails = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/find/product?${encodeURI(query)}`
  );
  return response.data;
};
export const saveMedicine = async (payload) => {
  const response = await nodeClient.post(
    `/service/private/v0/add/product`,
    payload
  );
  return response.data;
};
export const searchCompounds = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/search/generic/view?${encodeURI(query)}`
  );
  return response.data;
};
export const searchGlobalMedicine = async (query) => {
  const response = await nodeClient.get(
    `/service/private/v0/search/product?${encodeURI(query)}`
  );
  return response.data;
};
export const searchItemType = async () => {
  const response = await nodeClient.get(`/service/private/v0/list/itemtype`);
  return response.data;
};
